import React from 'react';
import {Alert, Button} from 'react-bootstrap';
import QueryString from './QueryString';
import './Buy.css';

function isKeyValid() { 
	return typeof QueryString.key === "string" && QueryString.key.length > 0 && QueryString.m === "0";
}

function getLinkToLicense(key) { 
	return "https://splinter-log.com/keys/" + key + "/splinter-license.spl";
}

class BuyResult extends React.Component {

	constructor(props) {
		super(props);
		this.state = { setSrc: false };
	}

	componentDidMount() {
		if(isKeyValid()) {
			setTimeout(
					() => { this.setState({ setSrc: true }); },
					1000
				);
		}
	}

	render() { 
		let alertMessage = null;
		let alertClass = null;
		let alertTitle = null;
		switch(QueryString.m) { 
			case "0": //success
				alertClass = "success";
				alertTitle = "Thank you for your purchase of Splinter!"
				alertMessage = (<div>
					<p>Your license will begin downloading immediately. You should also receive an email with the attached license for safe keeping.</p>
					<p>If the download doesn't begin automatically, <a className="blue-link" href={getLinkToLicense(QueryString.key)}>click here</a> to initiate it. This link will expire in 24 hours.</p>
					<p>To enable the license, download Splinter and enter it through Settings > Licenses.</p> 
					</div>
				);
				break;
			default:
			case "1": //user error
				alertClass = "warning";
				alertTitle = "Incorrect form parameters!"
				alertMessage = (<div>
						<p>Please make sure you enter valid parameters in the payment form, making sure you accept the EULA and entering your email correctly.</p>
					</div>);
				break;
			case "2": //internal error
				alertClass = "danger";
				alertTitle = "Ops! Something went very wrong!"
				alertMessage = (<div>
						<p>An internal error has occurred with this transaction. Please try again later.</p>
					</div>);
				break;
			case "4": //payment error
				alertClass = "warning";
				alertTitle = "There was an error with your order!"
				alertMessage = (<div>
						<p>An error occurred when we tried to process your payment. Please ensure your payment instrument is valid and is accurately entered.</p>
						<Button bsSize="small"  href="https://splinter-log.com/#/buy">Try Again</Button>
					</div>);
				break;

		}

		return (
			<div className="pageContents">

				<Alert bsClass="rounded-corner alert" bsStyle={alertClass}>
					<h4>{alertTitle}</h4>
					{alertMessage}
				</Alert>
				<iframe id="download_frame" style={{display: 'none'}} src={ this.state.setSrc === true ? 
					getLinkToLicense(QueryString.key) : ''
				}></iframe>
			</div>
		);
	}
}

export default BuyResult;


// WEBPACK FOOTER //
// ./src/BuyResult.js